import React, { PureComponent } from 'react';
import { Breadcrumb, BreadcrumbItem, Col, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';

// components
import ContactForm from '../../forms/contact-form/contact-form';

// ducks
import { CONTACT_SUBMIT } from '../../ducks/Home';

// modules
import styles from '../Containers.module.scss';

// constants
import states from '../../constants/states';

class ContactUs extends PureComponent {
  render() {
    const { hideBreadcrumb } = this.props;
    return (
      <Container fluid className={styles.ContactForm}>
        {!hideBreadcrumb && (
          <Container>
            <Row>
              <Breadcrumb>
                <LinkContainer exact to="/">
                  <BreadcrumbItem>
                    <Link to="/">Home</Link>
                  </BreadcrumbItem>
                </LinkContainer>
                <LinkContainer exact to="/contact-us">
                  <BreadcrumbItem active>Contact</BreadcrumbItem>
                </LinkContainer>
              </Breadcrumb>
            </Row>
          </Container>
        )}
        <Container>
          <Row>
            <Col xs={12} md={{ size: 6, offset: 3 }}>
              <ContactForm
                states={states}
                initialValues={{
                  firstName: '',
                  lastName: '',
                  email: '',
                  city: '',
                  state: 'FL',
                  contactWorkingWith: '',
                  contactMember: '',
                  comments: '',
                  suggestions: ''
                }}
                onSubmit={this.handleSubmit}
              />
            </Col>
          </Row>
        </Container>
      </Container>
    );
  }

  handleSubmit(values, dispatch, props) {
    return CONTACT_SUBMIT({
      ...values,
      type: 'general'
    });
  }
}

export default ContactUs;



// WEBPACK FOOTER //
// ./src/containers/ContactUs/ContactUs.js